import { Component, OnInit, Inject, NgZone,ViewChild,ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog} from '@angular/material/dialog';
import { DataService } from 'src/app/services/data.service';
import { NotifierService } from 'angular-notifier';
import { FormGroup, FormControl, Validators,FormArray,FormBuilder } from '@angular/forms';
import * as moment from 'moment';



@Component({
  selector: 'app-confirm-listado-iniciativas-admin',
  templateUrl: './confirm-listado-iniciativas-admin.component.html',
  styleUrls: ['./confirm-listado-iniciativas-admin.component.css']
})
export class ConfirmListadoIniciativasAdminComponent implements OnInit {
  confirmComentarios:boolean=false;
  name:string;
  email:string;
  id_iniciativa:number;
  id_periodo:number;
  folioIniciativa:number;
  agregarComentario:boolean=false;
  confirmEliminarPeriodo:boolean=false;
  confirmAddPeriodo:boolean=false;
  confirmAUpdatePeriodo:boolean=false;
  tituloAdd:string;
  tituloUpdate:string;
  formNuevoPeriodo: FormGroup;
  formEditarPeriodo: FormGroup;
  //Motivos
  id_motivo:number;
  tituloAddMotivos:string;
  confirmAddMotivo:boolean=false;
  formMotivos: FormGroup;
  listTipoMotivos:any[];
  confirmEliminarMotivo:boolean=false;
  tituloUpdateMotivo:string;
  confirmAUpdateMotivo:boolean=false;
  //Estructura
  confirmEliminarEstructura:boolean=false;
  confirmAUpdateEstructura:boolean=false;
  id:number;
  tituloUpdateEstructura:string;
  nombreEtiqueta:string;

  //Relaciones
  confirmAUpdateRelacion:boolean=false;
  confirmAUpdateRelacionGralArea:boolean=false;
  listaDirGralSinSub:any[]=[];
  listaSubsecretaria:any[]=[];
  listaDirGral:any[]=[];
  listaAreas:any[]=[];
  idSub:number;
  idDirGral:number;

  //Nuevo enlace
  confirmNuevoEnlace:boolean=false;

  //Area dueña
  confirmEliminarArea:boolean=false;
  confirmAUpdateaArea:boolean=false;
  idArea:number;
  tituloUpdateArea:string;
  nombreEtiquetaArea:string;

  //Aplicaciones
  tituloUpdateApp:string;
  confirmAUpdateaApp:boolean=false;
  confirmAUpdateRelacionAreaApp:boolean=false;





  constructor(private dataService: DataService,
    private notifier: NotifierService,
    @Inject(MAT_DIALOG_DATA) 
              public data: string) { }

  ngOnInit(): void {
    //Inicializamos el form para agregar periodos de envio
    this.formNuevoPeriodo = new FormGroup({
      fechaInicio_periodoEnvio: new FormControl('', [Validators.required]),
      fechaTermino_periodoEnvio: new FormControl('', [Validators.required])
    });

    //Inicializamos el form para agregar periodos de envio
    this.formMotivos = new FormGroup({
      descripcion_motivo: new FormControl('', [Validators.required]),
      id_tipoMotivo: new FormControl('', [Validators.required])
    });
    
    if(this.data['opcion']==10)
    {this.confirmComentarios=true;
      this.name=this.data['userName'];
      this.email=this.data['email'];
      this.id_iniciativa=this.data['id_iniciativa'];
      this.data="";
      this.folioIniciativa=this.data['folio'];
    }
    //Opcion para eliminar los periodos de envio
    if(this.data['opcion']==12)
    {
      this.confirmEliminarPeriodo=true;
      this.id_periodo=this.data['id_periodo'];
    }
    //Opcion para agregar los periodos de envio
    if(this.data['opcion']==13)
    {
      this.tituloAdd=this.data['titulo'];
      this.confirmAddPeriodo=true;
    }
    //Opcion para editar los periodos de envio
    if(this.data['opcion']==14)
    {
      this.tituloUpdate=this.data['titulo'];
      this.confirmAUpdatePeriodo=true;
      let idPeriodo=this.data['id_periodo'];
      this.infoUpdatePeriodo(idPeriodo);
    }
    //Opcion para agregar motivos
    if(this.data['opcion']==15)
    {
      //Agregar tipo de motivos
      this.dataService.getTipoMotivos().subscribe(
        data => {
          if (data['data']) {
            this.listTipoMotivos = data['data'];
          }
        },
        error => {
          console.log(error);
        }
      );

      this.tituloAddMotivos=this.data['titulo'];
      this.confirmAddMotivo=true;
    }
    //Opcion para eliminar los periodos de envio
    if(this.data['opcion']==16)
    {
      this.confirmEliminarMotivo=true;
      this.id_motivo=this.data['id_motivo'];
    }
    //Opcion para editar los motivos
    if(this.data['opcion']==17)
    {
      //Agregar tipo de motivos
      this.dataService.getTipoMotivos().subscribe(
        data => {
          if (data['data']) {
            this.listTipoMotivos = data['data'];
          }
        },
        error => {
          console.log(error);
        }
      );
      this.tituloUpdateMotivo=this.data['titulo'];
      this.confirmAUpdateMotivo=true;
      let idMotivo=this.data['id_motivo'];
      this.infoUpdateMotivo(idMotivo);
    }
    //Opcion para eliminar la subsecretaria
    if(this.data['opcion']==18)
    {
      this.confirmEliminarEstructura=true;
      this.id=this.data['id'];
    }
    //Opcion para editar las subsecretarias
    if(this.data['opcion']==19)
    {
      this.nombreEtiqueta=this.data['etiqueta']
      this.tituloUpdateEstructura=this.data['titulo'];
      this.confirmAUpdateEstructura=true;
      let id=this.data['id'];
      this.infoUpdateSubse(id);
    }
    //Opcion para editar las direcciones generales
    if(this.data['opcion']==20)
    {
      this.nombreEtiqueta=this.data['etiqueta']
      this.tituloUpdateEstructura=this.data['titulo'];
      this.confirmAUpdateEstructura=true;
      let id=this.data['id'];
      this.infoUpdateDirGral(id);
    }
    //Opcion para eliminar la dirección gral.
    if(this.data['opcion']==21)
    {
      this.confirmEliminarEstructura=true;
      this.id=this.data['id'];
    }
    //Opcion para editar las direcciones de area
    if(this.data['opcion']==22)
    {
      this.nombreEtiqueta=this.data['etiqueta']
      this.tituloUpdateEstructura=this.data['titulo'];
      this.confirmAUpdateEstructura=true;
      let id=this.data['id'];
      this.infoUpdateDirArea(id);
    }

    //Opcion para editar la direccion general de una subsecretaria
    if(this.data['opcion']==23)
    {
      this.nombreEtiqueta=this.data['etiqueta']
      this.tituloUpdateEstructura=this.data['titulo'];
      this.confirmAUpdateRelacion=true;
      //this.data=this.data['id'];
      this.id=this.data['id'];
      this.idSub=this.data['idSubsecretaria'];
      //Cargamos el combo de direccion gral
      this.cargarSubsecretarias();
      this.infoUpdateDirGral(this.id);
    }

    //Opcion para editar la direccion general de una direccion de area
    if(this.data['opcion']==24)
    {
      this.nombreEtiqueta=this.data['etiqueta']
      this.tituloUpdateEstructura=this.data['titulo'];
      this.confirmAUpdateRelacionGralArea=true;
      //this.data=this.data['id'];
      this.id=this.data['id'];
      this.idDirGral=this.data['idDirGral'];
      //Cargamos el combo de direccion gral
      this.cargarDireccionGral();
      this.infoUpdateDirArea(this.id);
    }

    //Opcion para guardar nuevo enlace
    if(this.data['opcion']==25)
    {
      this.confirmNuevoEnlace=true;
      //his.id=this.data['id'];
    }

    //Opcion para editar las areas dueñas
    if(this.data['opcion']==26)
    {
      this.nombreEtiqueta=this.data['etiqueta']
      this.tituloUpdateArea=this.data['titulo'];
      this.confirmAUpdateaArea=true;
      let id=this.data['id'];
      this.infoUpdateArea(id);
    }

     //Opcion para eliminar areas/aplicaciones
     if(this.data['opcion']==27)
     {
       this.confirmEliminarArea=true;
       //this.id=this.data['id'];
     }

     //Opcion para editar las areas dueñas
    if(this.data['opcion']==28)
    {
      this.nombreEtiqueta=this.data['etiqueta']
      this.tituloUpdateApp=this.data['titulo'];
      this.confirmAUpdateaApp=true;
      let id=this.data['id'];
      this.infoUpdateApp(id);
    }

    
    //Opcion para editar la direccion general de una subsecretaria
    if(this.data['opcion']==29)
    {
      this.nombreEtiqueta=this.data['etiqueta']
      this.tituloUpdateEstructura=this.data['titulo'];
      this.confirmAUpdateRelacionAreaApp=true;
      this.id=this.data['id'];
      this.idArea=this.data['idArea'];
      //Cargamos el combo de areas
      this.cargarAreas();
      this.infoUpdateApp(this.id);
    }



  }

  get fc() {
    return this.formNuevoPeriodo.controls;
  }
  get f() {
    return this.formNuevoPeriodo;
  }

  //Form de motivos
  get fm() {
    return this.formMotivos.controls;
  }
  get m() {
    return this.formMotivos;
  }

  
  //Método para cargar las subsecretarias
  cargarSubsecretarias()
  {
    
    this.dataService.getListSubsecretarias().subscribe(
      data => {
        this.listaSubsecretaria = data['data'];
      },
      error => {
        console.error(error);       
      }
    );
  }

  //Método para cargar las direcciones generales
  cargarDireccionGralSinSub()
  {
    this.dataService.getListDireccionesGral().subscribe(
      data => {
        this.listaDirGralSinSub = data['data'];
        //this.dataSourceDGS.data=this.listaDirGralSinSub;
      },
      error => {
        console.error(error);       
      }
    );
  }

  //Método para cargar las subsecretarias
  //Método para cargar las subsecretarias
  cargarDireccionGral()
  {
    this.dataService.getListDireccionesGral().subscribe(
      data => {
        this.listaDirGral = data['data'];
      },
      error => {
        console.error(error);       
      }
    );
  }

  //Método para editar periodo de envio
  infoUpdatePeriodo(id:number)
  {
    //Mapeamos los valores del form
    this.dataService.getPeriodoEnviobyId(id).subscribe(data => {
      if (data['objData']) 
      {
        let infoPeriodo:any=data['objData'];
        this.formNuevoPeriodo.patchValue({
          fechaInicio_periodoEnvio:moment(infoPeriodo.fechaInicio_periodoEnvio).format('YYYY-MM-DD'),
          fechaTermino_periodoEnvio:moment(infoPeriodo.fechaTermino_periodoEnvio).format('YYYY-MM-DD')
        });
      }
    });
  }

  //Método para obtener la informacion del motivo
  infoUpdateMotivo(id:number)
  {
    //Mapeamos los valores del form
    this.dataService.getMotivobyId(id).subscribe(data => {
      if (data['objData']) 
      {
        let infoMotivos:any=data['objData'];
        this.formMotivos.patchValue({
          descripcion_motivo:infoMotivos.descripcion_motivo,
          id_tipoMotivo:infoMotivos.id_tipoMotivo,
        });
      }
    });
  }

  //Método para obtener la informacion de la subsecretaria
  infoUpdateSubse(id:number)
  {
    //Mapeamos los valores del form
    this.dataService.getSubsecretariabyId(id).subscribe(data => {
      if (data['objData']) 
      {
        this.data=data['objData']['nombre_subsecretariaSap'];
      }
    });
  }

  //Método para obtener la informacion de la dirección gral.
  infoUpdateDirGral(id:number)
  {
    //Mapeamos los valores del form
    this.dataService.getDirGralById(id).subscribe(data => {
      if (data['objData']) 
      {
        this.data=data['objData']['nombre_dirgralSap'];
      }
    });
  }

  //Método para obtener la informacion de la dirección de area.
  infoUpdateDirArea(id:number)
  {
    //Mapeamos los valores del form
    this.dataService.getDirAreaById(id).subscribe(data => {
      if (data['objData']) 
      {
        this.data=data['objData']['nombre_areaSap'];
      }
    });
  }


  
  //Método para obtener la informacion del area
  infoUpdateArea(id:number)
  {
    //Mapeamos los valores del form
    this.dataService.getAreaById(id).subscribe(data => {
      if (data['objData']) 
      {
        this.data=data['objData']['nombre_area'];
      }
    });
  }

   
  //Método para obtener la informacion de la app
  infoUpdateApp(id:number)
  {
    //Mapeamos los valores del form
    this.dataService.getAppById(id).subscribe(data => {
      if (data['objData']) 
      {
        this.data=data['objData']['nombre_aplicacion'];
      }
    });
  }

  //Método para cargar las áreas dueñas
  cargarAreas()
  {
    this.dataService.obtenerGruposSistemas().subscribe(
      data => {
        this.listaAreas = data['data'];
      },
      error => {
        console.error(error);       
      }
    );

  }



}
